// 静态路由，不需要区分用户权限的
export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    name: 'home',
    path: '/home',
    meta: {
      module: 'home',
    },
    component: () => import('@/pages/index.vue'),
  },
  {
    path: '/project/:id',
    meta: {
      module: 'project',
    },
    component: () => import('@/pages/index.vue'),
  },
  {
    path: '/lc/:code',
    meta: {
      module: 'lc',
    },
    component: () => import('@/pages/index.vue'),
  },
  // {
  //   path: '/detail',
  //   meta: {
  //     module: 'detail',
  //   },
  //   component: () => import('@/pages/detail.vue'),
  // },
]
